import { RedcatApiHandler } from 'polygon-utils';
import { OrderingUtils } from 'polygon-ordering';
import type { TopUpLimits } from '../../utils/topUpLimits';

const { dollarsToCents } = OrderingUtils;

export type { TopUpLimits as GiftCardLimits } from '../../utils/topUpLimits';
export {
  effectiveMinTopUpCents,
  effectiveMaxTopUpCents,
  formatCents,
  isAboveMinTopUp,
  isWithinMaxTopUp,
} from '../../utils/topUpLimits';

/**
 * Looks up a gift card by its member number and PIN and returns its top-up
 * limits and current balance, all converted to cents. Throws if the card
 * number/PIN combination is invalid.
 */
export const fetchGiftCardLimits = async (
  memberNo: string,
  verifyPIN: string,
): Promise<TopUpLimits> => {
  const res = await RedcatApiHandler.authorisedFetch({
    method: 'POST',
    path: '/api/v1/members/giftcard_balance',
    body: { MemberNo: memberNo, VerifyPIN: verifyPIN },
  });

  return {
    minTopupCents: dollarsToCents(res.data.MinTopup),
    maxTopupCents: dollarsToCents(res.data.MaxTopup),
    minMoneyBalanceCents: dollarsToCents(res.data.MinMoneyBalance),
    maxMoneyBalanceCents: dollarsToCents(res.data.MaxMoneyBalance),
    moneyCents: dollarsToCents(res.data.Money),
  };
};
